import { NEW_ITEM_ID } from '@/constants/campaignManagement';
import * as yup from 'yup';

export const requiredNumberValidationSchema = (requiredMessage = 'Field is required') =>
  yup
    .number()
    .nullable()
    .transform((_v, orig) => {
      const raw = orig && typeof orig === 'object' && 'target' in orig ? orig.target?.value : orig;
      if (raw === '' || raw == null) return null;
      const n = Number(raw);
      return Number.isNaN(n) ? null : n;
    })
    .test('required', requiredMessage, value => value !== null && value !== undefined)
    .test('min', 'Must be a positive number', value => value === null || value === undefined || value >= 0);

const checkProductRequired = (id: number | string) => id === NEW_ITEM_ID;

export const dv360TicketsLineItemFormValidationSchema = (showBidCpm: boolean) =>
  yup.object().shape({
    id: yup.mixed(),
    name: yup.string().required('Line Item Name is required').default(''),
    budget: requiredNumberValidationSchema('Wholesale Budget is required'),
    bidCpm: showBidCpm
      ? requiredNumberValidationSchema('Bid CPM is required').test(
          'positive',
          'Must be greater than 0',
          value => value === null || value === undefined || value > 0,
        )
      : yup.mixed().nullable(),
    startDate: yup.mixed().nullable(),
    endDate: yup.mixed().nullable(),
    altId: yup.string().default(''),
    product: yup
      .mixed()
      .nullable()
      .when(['id'], {
        is: checkProductRequired,
        then: schema => schema.required('Product is required'),
        otherwise: schema => schema.nullable(),
      }),
    geo: yup.object().shape({
      included: yup.array().default([]),
      excluded: yup.array().default([]),
    }),
    creatives: yup.array().default([]),
    audiences: yup.object().default({}),
    daypart: yup.object().default({}),
  });

export const duplicateDv360TicketsLineItemFormValidationSchema = yup.object().shape({
  name: yup.string().required('Line Item Name is required').default(''),
  budget: requiredNumberValidationSchema('Wholesale Budget is required'),
  startDate: yup.mixed().nullable(),
  endDate: yup.mixed().nullable(),
  product: yup.object().required(),
});
